<template>
    <v-toolbar app>
         <img src="../../../static/images/smartkidsmarket-logo.svg" class="ma-1" style="height:60px" />
         <v-toolbar-title class=" mr-4">
           <span v-if="$vuetify.breakpoint.smAndUp"> SmartKidsMarket {{title}}</span>
         </v-toolbar-title>
         <v-spacer></v-spacer>
         <v-toolbar-items v-if="uid != null">
           <v-btn flat :to="{name: 'Help'}">Help</v-btn>
           <v-btn @click.stop="$router.push({ name: 'Dashboard' })" flat>Dashboard</v-btn>
         </v-toolbar-items>
         <v-toolbar-items v-else>
           <v-btn @click.stop="$router.push({ path: '/login' })" flat>Login</v-btn>
         </v-toolbar-items>

    </v-toolbar>
</template>

<script>
import {mapState} from 'vuex'


export default {
  computed: {
    ...mapState({
      uid: state => state.admin.uid,
    }),
    myStyle: function () {
      return `color: ${this.accentColor}; font-weight:bold;`
    }
  },
  props: ['title'],
  data () {
    return {
    }
  }
}
</script>

<style scoped>
/* "scoped" attribute limit the CSS to this component only */

</style>
